import { getStore } from "../store/Store";
import { SxSReadingPaneMode } from "../store/schema/SxSReadingPaneState";

export const isItemInSxS = (itemId: string): boolean => {
    const store = getStore();
    
    return [...store.sxsStoreMapping.values()].some(sxsStore => {
        return ((sxsStore.readingPaneState?.mode === SxSReadingPaneMode.ItemReadingPane &&
            sxsStore.readingPaneState?.itemId?.Id === itemId) ||
            sxsStore.extendedViewState.attachmentId?.Id === itemId);
    });
};
